import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from '../shared/submit-button-shared';
import { ButtonShared } from '../shared/button-shared';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { Subscription } from 'rxjs';
import { GenerateShared } from '../shared/generate-shared';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, OnDestroy {
  @Input() config: ButtonInputModel;

  isActive = false;

  subscription: Subscription;

  constructor(
    private buttonShared: ButtonShared,
    private submitButtonShared: SubmitButtonShared,
    private generateService: GenerateService,
    private generateShared: GenerateShared
  ) {}

  ngOnInit() {
    // console.log(this.config)
    if (this.config.isSelected) {
      this.isActive = this.config.isSelected;
    }
    switch (this.config.type) {
      case 'diet-type': {
        this.subscription = this.buttonShared.dietTypeButtonClickObs$.subscribe(
          (id) => {
            if (id !== -1 && this.config.id !== id) {
              this.isActive = false;
            }
          }
        );
        break;
      }
      case 'activity': {
        this.subscription = this.buttonShared.activityButtonClickObs$.subscribe(
          (id) => {
            if (id !== -1 && this.config.id !== id) {
              this.isActive = false;
            }
          }
        );
        break;
      }
      case 'difficulty': {
        this.subscription =
          this.buttonShared.difficultyButtonClickObs$.subscribe((id) => {
            if (id !== -1 && this.config.id !== id) {
              this.isActive = false;
            }
          });
        break;
      }
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  clicked(e) {
    if (
      e.srcElement.id === 'one-line-body' ||
      e.srcElement.parentElement.id === 'one-line-body'
    ) {
      this.buttonShared.dietTypeButtonClicked(this.config.id);
      let bar =
        e.srcElement.id === 'one-line-body'
          ? e.srcElement
          : e.srcElement.parentElement;
      if (!this.isActive) {
        this.isActive = !this.isActive;
      }
      this.animate(bar);
      let type = '';
      switch (this.config.id) {
        case 0: {
          type = 'weightLoss';
          break;
        }
        case 1: {
          type = 'weightFix';
          break;
        }
        case 2: {
          type = 'weightGain';
          break;
        }
        case 3: {
          type = 'pregnancy';
          break;
        }
        case 4: {
          type = 'breastfeeding';
          break;
        }
      }
      if (this.isActive) {
        setTimeout(() => {
          this.generateService.dietTypeSelected(type);
        }, 100);
      }
    }
    if (
      e.srcElement.id === 'two-line-body' ||
      e.srcElement.parentElement.id === 'two-line-body'
    ) {
      this.buttonShared.activityButtonClicked(this.config.id);
      let bar =
        e.srcElement.id === 'two-line-body'
          ? e.srcElement
          : e.srcElement.parentElement;
      this.isActive = !this.isActive;
      this.animate(bar);
      if (this.isActive) {
        this.generateService.activitySelected(this.config.id);
      } else {
        this.generateService.activitySelected(-1);
      }
    }
    if (
      e.srcElement.id === 'two-line-body-no-img' ||
      e.srcElement.parentElement.id === 'two-line-body-no-img'
    ) {
      if (this.config.isDisabled) {
        this.generateShared.showPopup();
      } else {
        this.buttonShared.difficultyButtonClicked(this.config.id);
        let bar =
          e.srcElement.id === 'two-line-body-no-img'
            ? e.srcElement
            : e.srcElement.parentElement;
        if (!this.isActive) {
          this.isActive = !this.isActive;
        }
        this.generateShared.difficulty = this.config.id;
        this.animate(bar);
        setTimeout(() => {
          this.submitButtonShared.nextButtonClicked();
        }, 200);
      }
    }
  }

  animate(bar: any) {
    bar.style.width = 'calc( 100% - 56px )';
    bar.style.right = '28px';
    setTimeout(() => {
      bar.style.width = 'calc( 100% - 48px )';
      bar.style.right = '24px';
    }, 100);
  }
}

export interface ButtonInputModel {
  isOneLine: boolean;
  title: string;
  type: string;
  imgUrl?: string;
  description?: string;
  id?: number;
  isSelected?: boolean;
  isDisabled?: boolean;
}
